// extracted by mini-css-extract-plugin
export default {"container":"BlocksSearch_container__LNm30","search":"BlocksSearch_search__GPYy8","search-status":"BlocksSearch_search-status__neEm0","button":"BlocksSearch_button__sfcRg"};